import { gql } from '@apollo/client';

import {
  FormatTranscriptAnswerDocument,
  type FormatTranscriptAnswerQuery,
  type FormatTranscriptAnswerQueryVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    query formatTranscriptAnswer($input: FormatTranscriptInput!) {
      formattedTranscriptAnswer(input: $input) {
        formattedTranscript
        extractedOptions
        extractedSubQuestionAnswers {
          subQuestionId
          value
        }
      }
    }
  `;
}

export const FORMAT_TRANSCRIPT_ANSWER = FormatTranscriptAnswerDocument;
export type {
  FormatTranscriptAnswerQuery,
  FormatTranscriptAnswerQueryVariables,
};
export type formatTranscriptAnswerQuery = FormatTranscriptAnswerQuery;
export type formatTranscriptAnswerQueryVariables =
  FormatTranscriptAnswerQueryVariables;
